import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Chevron-Left_b",
		children: /* @__PURE__ */ _jsx("path", {
			id: "fa-solid fa-chevron-left",
			d: "M4.63997 7.34325C4.27138 7.69351 4.27138 8.30646 4.63997 8.65672L10.0839 14.2609C10.4241 14.6403 11.0196 14.6403 11.3598 14.2609C11.7284 13.9106 11.7284 13.2976 11.3598 12.9474L6.56803 7.98539L11.3598 3.05258C11.7284 2.70232 11.7284 2.08937 11.3598 1.73911C11.0196 1.35967 10.4241 1.35967 10.0839 1.73911L4.63997 7.34325Z",
			fill: "#4F68CB"
		})
	})
});
export default SvgChevronLeft;
